<template>
    <div>
        <!-- 面料是否完成 -->
        <div v-if="isProduce">
            <success-icon slot="reference" v-if="order.apply_main_finish" text="完成"/>
            <danger-icon v-else text="否"></danger-icon>
        </div>
        <div v-else>
            <no-related-icon></no-related-icon>
        </div>
    </div>

</template>

<script>
    import SuccessIcon from "./SuccessIcon"
    import DangerIcon from "./DangerIcon"
    import NoRelatedIcon from "./NoRelatedIcon"

    export default {
        name: "ApplyMainFinish",
        components: {NoRelatedIcon, DangerIcon, SuccessIcon},
        props: {
            order: Object
        },
        computed: {
            isProduce() {
                return this.order.kind === 'FACTORY'
            }
        },
    }
</script>

<style scoped>

</style>